module.exports = __webpack_public_path__ + "static/media/12GalleryPuppets.3c708ad2.jpeg";